import React from "react";
import ReactDOM from "react-dom";

import { root } from "baobab-react/higher-order";
import Baobab from "baobab";
import {
	decode,encode
} from 'url-safe-base64'

import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import * as playerActions from "./actions/playerActions";

import config from "./config/config";
import env from "./constants/env";
import state from "./state";
import { captureQueryString, getQueryStringParam } from "./utils/utils";
import { initializeSecurityContext, initializeInjectedSecurityContextV2, initializeSecurityContextV2, initializeInjectedSecurityContext } from "./utils/securityUtils";

import smoothscroll from "smoothscroll-polyfill";
import _ from "lodash";

// kick off the polyfill!
smoothscroll.polyfill();

// global function for inline linking
window.playerActionsInlineLinkUrl = playerActions.inlineLinkUrl;

// Let's bind the component to the tree through the `root` higher-order component
let tree = new Baobab({});
const RootedApp = root(tree, App);
captureQueryString();
renderApp();

function renderApp() {
	// Rendering the app
	const authCallback = getQueryStringParam("authCallback");
	const authCallbackV2 = getQueryStringParam("authCallbackV2");
	const authCallbackV2_1 = getQueryStringParam("authCallbackV2_1");
	let authSuccess = false;
	let securityContextUri = null;
	let authResponse = null;
	if (authCallback || authCallbackV2) {
		try {
			authResponse = JSON.parse(atob(decode(authCallback ? authCallback : authCallbackV2)));
			console.log("Parsed auth callback", authResponse);
			authSuccess = authResponse.success;
		} catch (e) {
			console.warn(e);
			alert(e);
		}
	}
	const injectedSecurityCredentials = getQueryStringParam("_sec_ctx");
	const injectedSecurityCredentialsV2 = getQueryStringParam("_sec_ctx_v2");
	const requiresAuthentication = defaultParams.enableDataTracking && defaultParams.authUri && !injectedSecurityCredentials && !injectedSecurityCredentialsV2; // eslint-disable-line
	console.log("Requires Auth?, Success?", requiresAuthentication, authSuccess);
	if (requiresAuthentication && !authSuccess && !authCallbackV2_1) { // eslint-disable-line
		window.location.href = `${defaultParams.authUri}?auth=${encode(btoa(JSON.stringify({// eslint-disable-line
			redirectUri:window.location.href
		})))}`; // eslint-disable-line
	} else {
		if (requiresAuthentication && authCallback) {
			initializeSecurityContext(authResponse);
		} else if (requiresAuthentication && authCallbackV2) {
			// localStorage.setItem('authCallbackV2', JSON.stringify(authResponse));
			// const hasIndexHtml = window.location.href.indexOf("index.html") !== -1;
			// let redirectHost = hasIndexHtml ? window.location.href.split("/index.html?authCallbackV2")[0] : window.location.href.split("/?authCallbackV2")[0];
			// const redirectTarget = `${redirectHost}${hasIndexHtml ? "/index.html?authCallbackV2_1=true" : "/?authCallbackV2_1=true"}`;
			// // alert(redirectTarget);
			// window.location.href = redirectTarget;
			initializeSecurityContextV2(authResponse);
		} else if (requiresAuthentication && authCallbackV2_1) {
			// const authResponseStr = localStorage.getItem('authCallbackV2');
			// const authResponse = JSON.parse(authResponseStr);
			// initializeSecurityContextV2(authResponse);
		} else if (injectedSecurityCredentials) {
			initializeInjectedSecurityContext(injectedSecurityCredentials);
		} else if (injectedSecurityCredentialsV2) {
			initializeInjectedSecurityContextV2(injectedSecurityCredentials);
		}
		//passing in all params required by web player, simulate passing from external app by cloning state, config, and env
		ReactDOM.render(<RootedApp securityContextUri={securityContextUri} activities={activities} config={_.cloneDeep(config)} env={_.cloneDeep(env)} state={new Baobab(_.cloneDeep(state.get()))} />, document.getElementById("root")); // eslint-disable-line

	}

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: http://bit.ly/CRA-PWA
	serviceWorker.unregister();
}
